import { render, staticRenderFns } from "./QuestionTagPicker.vue?vue&type=template&id=37caa780&"
import script from "./QuestionTagPicker.vue?vue&type=script&lang=js&"
export * from "./QuestionTagPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports